import { render, staticRenderFns } from "./EventDateSettings.vue?vue&type=template&id=2e29ee1e&scoped=true&"
import script from "./EventDateSettings.vue?vue&type=script&lang=ts&"
export * from "./EventDateSettings.vue?vue&type=script&lang=ts&"
import style0 from "./EventDateSettings.vue?vue&type=style&index=0&id=2e29ee1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e29ee1e",
  null
  
)

export default component.exports